// @flow
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import type { Action } from 'services/actions/Action.type';
import rootReducer, { initialState } from 'services/reducers';
import rootSaga from '../sagas/root/root';
import type { State } from '../sharedTypes';

const enhancers = [];
const sagaMiddleware = createSagaMiddleware();
const middleware = [thunk, sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-underscore-dangle
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore<State, Action, (action: Action) => Action>(
  rootReducer,
  initialState,
  composedEnhancers
);
sagaMiddleware.run(rootSaga);

export default store;
